import type { IValidatedResponse } from '../../httpClient';
import { deleteRequest } from '../../httpClient';
import type { IDeleteCollectionSubtitleRequest } from './delete-collection-subtitle-request';
import type { IDeleteCollectionSubtitleResponse } from './delete-collection-subtitle-response';
import { deleteCollectionSubtitleResponseSchema } from './delete-collection-subtitle-response';

export async function deleteCollectionSubtitleApi({
  collectionId,
  subtitleId,
}: IDeleteCollectionSubtitleRequest): Promise<
  IValidatedResponse<IDeleteCollectionSubtitleResponse>
> {
  return deleteRequest<IDeleteCollectionSubtitleResponse>({
    path: `/sys/collections/${collectionId}/subtitles/${subtitleId}`,
    schema: deleteCollectionSubtitleResponseSchema,
  });
}
